module.exports = {
  title: AppConfig.PAGE_TITLE,
  DEFAULT_TEL: AppConfig.DEFAULT_TEL,
  baseUrl: AppConfig.API_URL,
  socketServer: AppConfig.SOCKET_URL,
  //是否支持当天数据查询
  supportTodayDataQuery: AppConfig.SupportTodayDataQuery,
  routeStartTime: {}

}
